// Keenthemes' plugins
window.KTComponents = require('../../assets/js/components/_init.js');